export default "__VITE_ASSET__BSYnRahd__"